import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import AlertMessage from '@components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { questionsRequest } from './common/types';
import useResetPassword from './hooks/useResetPassword';
import { AuthenticationInformationForm } from './AuthenticationInformationForm';
import Header from './Header';

const ResetPasswordForm: React.FC = () => {
    const intl = useIntl();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const hhid = searchParams.get('hhid');

    const {
        questions,
        submitQuestionValidation,
        shouldRedirect,
        redirectData,
        hasError,
        errorMessage,
        shouldShowQuestions,
    } = useResetPassword({
        encHHId: hhid || '',
    });

    useEffect(() => {
        if (shouldRedirect) {
            navigate(redirectData.url, { state: { email: redirectData.email } });
        }
    }, [shouldRedirect, redirectData]);

    const handleSubmit = (data: questionsRequest) => {
        submitQuestionValidation(data);
    };

    return (
        <>
            <Header title={intl.formatMessage({ id: 'resetPassword.questions.form.title' })} />
            <ConditionalRendering isTrue={hasError}>
                <AlertMessage showIcon={false} content={errorMessage} type="error" />
            </ConditionalRendering>
            <ConditionalRendering isTrue={shouldShowQuestions}>
                <AuthenticationInformationForm fields={questions} onSubmit={handleSubmit} />
            </ConditionalRendering>
        </>
    );
};

export default ResetPasswordForm;
